import axios from 'axios';

export interface callApiResult {
    success: boolean;
    data?: any;
    error?: any
};

const getToken = async () => {
    let token = "";
    try {
        // const session = await Auth.currentSession()
        token = "token"//session.getIdToken().getJwtToken()
    } catch (error) {
        //FIX LOG IN
        // store.dispatch({
        //     type: "SESSION_EXPIRED",
        // } as SessionExpiredAction);
    }
    return token;
};

export const post = async (url: string, params: object | null) => {
    const token = await getToken();
    try {
        const res = await axios.post(`${process.env.REACT_APP_APIGW_URL}${url}`, params, { headers: { 'Authorization': token } })
        return {
            success: res.status === 200,
            data: res.data,
        } as callApiResult;
    } catch (err) {
        return {
            success: false,
            data: null,
            error: err,
        } as callApiResult;
    }
};

export const getUser = async (sub: string, username: string) => {
    const token = await getToken();
    const getUserUrl = "/user/get";
    const params = {sub, username}
    try {
        const res = await axios.post(`${process.env.REACT_APP_APIGW_URL}${getUserUrl}`, params, { headers: { 'Authorization': token } })
        return {
            success: res.status === 200,
            data: res.data,
        } as callApiResult;
    } catch (err) {
        return {
            success: false,
            data: null,
            error: err,
        } as callApiResult;
    }
};

export const getUserInfo = async (email: string, password: string) => {
    const token = await getToken();
    const getUserUrl = "/user/get-user";
    const params = {email, password}
    try {
        const res = await axios.post(`${process.env.REACT_APP_APIGW_URL}${getUserUrl}`, params, { headers: { 'Authorization': token } })
        return {
            success: res.status === 200,
            data: res.data,
        } as callApiResult;
    } catch (err) {
        return {
            success: false,
            data: null,
            error: err,
        } as callApiResult;
    }
};

// #endregion
